export interface IncidentUpdates {
  id: string;
  status: IncidentStatus;
  created_at: string;
  body: string;
}

export interface Incident {
  id: string;
  created_at: string;
  incident_updates: IncidentUpdates[];
  name: string;
  status: IncidentStatus;
}

export interface StatusApiResponse {
  incidents: Incident[];
}

export enum IncidentStatus {
  investigating = 'investigating',
  identified = 'identified',
}
